export const howItsWorks = ({ primary, secondary }) => {
  return {
    icons: {
      color: `rgba(${primary}, 1)`
    }
  }
};